var _learnq = _learnq || [];

// Expand Shopify JS API
Shopify = Shopify || {};

Shopify.queue = [];

Shopify.handleize = function(str) {
  return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
};

Shopify.moveAlong = function() {
  // If we have requests in the queue, process the next one.
  if (Shopify.queue.length) {
    var request = Shopify.queue.shift();
		Shopify.addItem(request.variantId, request.quantity, Shopify.moveAlong);
  } else {
    if($('body').hasClass('template-cart')){
      Lemonade.cartPage.renderCartPage();
    } else {
      Lemonade.cart.renderCartFlyout(true);
    }
	}
}; 

Shopify.changeAlong = function(){
	// If we have requests in the queue, process the next one.	
	if (Shopify.changeQueue.length) {
		var request = Shopify.changeQueue.shift();
		Shopify.changeItem(request.lineId, request.quantity, Shopify.changeAlong);
	} 
	else {
    Shopify.setMonograms();
	}
};

Shopify.setMonograms = function(){
  
  jQuery(function($) {
    // get last recorded car
    cartitems = Lemonade.cache.lastCart;

    // if empty cart, try twice
    if ((cartitems.length == 0) && (Lemonade.cache.lastIter < 2)) {
      $.getJSON('/cart.js', function(cart){
        Lemonade.cache.lastCart = cart.items;
        Lemonade.cache.lastIter += 1;
        Shopify.setMonograms();
      });
      return;
    }

    // calculate number of monograms to add.
    hasMonogram = false;
    currentCount = 0;
    monogram_qty = 0;

    $.each(cartitems, function(i,o){
      if (o.handle == 'monogram') {
        hasMonogram = true;
        currentCount = o.quantity
      }
      if (o.properties){
        if (o.properties.Monogram != null || o.properties['Marin Monogram'] != null || o.properties['Chunky Monogram'] != null){
          monogram_qty += o.quantity;
        }
      }
    })

    //if the monogram count has not changed, exit.
    if (currentCount == monogram_qty) {
      if($('body').hasClass('template-cart')){
        Lemonade.cartPage.renderCartPage();
      } else {
        Lemonade.cart.renderCartFlyout(true);
      }
      return;
    }

    // if no monograms exist, but there is a quantity, add monogram product.
    if (!hasMonogram && (monogram_qty > 0)) {
      if($('body').hasClass('template-cart')){
        Shopify.addItem(Lemonade.cache.monogram_id, monogram_qty, Lemonade.cart.renderCartPage);
      } else {
        Shopify.addItem(Lemonade.cache.monogram_id, monogram_qty, Lemonade.cart.renderCartFlyout);
      }
      return;
    }
  
    // update the monogram value.
    var params = {
  		type: "POST",
  		url: "/cart/change.js",
  		data: "id=" + Lemonade.cache.monogram_id + "&quantity=" + monogram_qty,
  		dataType: "json",
  		success: function(cart) {
  		  Lemonade.cache.lastCart = cart.items;
        if($('body').hasClass('template-cart')){
          Lemonade.cartPage.renderCartPage();
        } else {
          Lemonade.cart.renderCartFlyout(true);
        }
  		},
  		error: function(line, monogram_qty) {
  			Shopify.onError(line, monogram_qty);
  		}
  	};

  	jQuery.ajax(params);
  });
}

Shopify.changeItem = function(line, qty, callback){
	var params = {
		type: "POST",
		url: "/cart/change.js",
		data: "line=" + line + "&quantity=" + qty,
		dataType: "json",
		success: function(cart) {

		  Lemonade.cache.lastCart = cart.items;

      // FREE GIFT
      // Is Gift Product feature enabled and a free product variant ID added in Theme Settings?
      if(liquidVars.giftEnable && liquidVars.giftProduct != null){
        // Any time the cart total is updated through line item quantity changes we need to determine if the customer still qualifies for the free product
        // Is the free gift already in the cart?
        if(Lemonade.cache.freeGiftAdded){
          // Is the current price of the cart too low to qualify for the free gift?
          if(cart.total_price <= liquidVars.giftThreshold){
            // Remove the Free Gift
            jQuery.ajax({
              type: "POST",
              url: "/cart/change.js",
              data: "id=" + liquidVars.giftProduct + "&quantity=0",
              dataType: "json",
              success: function(cart) {
                "function" == typeof callback ? callback(cart) : Shopify.onCartUpdate(cart);
                // Update the Cart Header UI
                // Difference between cart total and free gift threshold
                const amountAway = parseInt(liquidVars.giftThreshold) - parseInt(cart.total_price);
                // Update the amount away from free gift
                Lemonade.cache.$giftProgress.text(Shopify.formatMoneyCustom(amountAway));
                // Hide the button that allows free gift to be added to the cart
                Lemonade.cache.$addFreeGiftButton.addClass('hide');
                // Show the messaging letting the user know how much further till they've crossed the price threshold
                Lemonade.cache.$giftMessage.show();
                // The gift messaging header of the cart
                Lemonade.cache.$giftHeader.show();
                // Reassign the global variable
                Lemonade.cache.hasFreeGift = false;
              },
              error: function(line, qty) {
                Shopify.onError(line, qty);
              }
            });
          } else {
            // The Free gift is in the cart
            // Hide the gift header UI in the cart flyout (not needed when product is in cart)
            Lemonade.cache.$giftHeader.hide();
          }
          // Run the callback to update the cart flyout
          "function" == typeof callback ? callback(cart) : Shopify.onCartUpdate(cart);
        } else {
          // The Free gift is not yet in the cart
          // Update the cart header UI based on the state of the gift product
          if(cart.total_price <= liquidVars.giftThreshold){
            Lemonade.cache.$addFreeGiftButton.addClass('hide');
            Lemonade.cache.$giftMessage.show();
          } else {
            Lemonade.cache.$addFreeGiftButton.removeClass('hide');
            Lemonade.cache.$giftMessage.hide();
          }
          // Run the callback to update the cart flyout
          "function" == typeof callback ? callback(cart) : Shopify.onCartUpdate(cart);
        }
      } else {
        "function" == typeof callback ? callback(cart) : Shopify.onCartUpdate(cart);
      }

		},
		error: function(line, qty) {
			Shopify.onError(line, qty);
		}
	};
	jQuery.ajax(params);
}

Shopify.onCartUpdate = function(){
	return;
}

Shopify.formatMoneyCustom = function(price){
  return theme.Currency.formatMoney(price,theme.moneyFormat)
	//return Shopify.formatMoney(price, "").replace('.00', '');
}

Shopify.queryParams = function(name, url){
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

theme.Currency = (function() {
  var moneyFormat = '$'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();




window.Lemonade = window.Lemonade || {};

function convertNumber(val) {
  return theme.Currency.formatMoney(val,theme.moneyFormat).replace('.00', '');
}


// API for utility functions
var Utilities = (function() {
  
  return {
  
    openCartFlyout: function(){
      Utilities.resizeCartFlyout();
      Lemonade.cache.$cartFlyout.addClass('show');
      Lemonade.cache.$header.addClass('cart-open');
      Lemonade.cache.$screenCover.show();
      Lemonade.noScroll();
    },

    closeCartFlyout: function(){
      Lemonade.cache.$cartFlyout.removeClass('Show');
    },

    getQueryParam: function(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },    

    addProductToCart: function(data, successCallback, errorCallback){
      $.ajax({ url: '/cart/add.js', type: 'post', dataType: 'json',
        data: data,
        success: function(data, textStatus, jqXHR) {
          if (textStatus === 'success') {

            // FREE GIFT
            // If the product that was just added to the cart is the free gift product set the global variable to true
            if(data.id == liquidVars.giftProduct){Lemonade.cache.freeGiftAdded = true}

            if($('body').hasClass('template-cart')){
              Lemonade.cartPage.renderCartPage();
            } else {
              Utilities.updateCart(successCallback, true);
            }

            // add to cart event tracking
            Lemonade.addToCartEvent(data);
            
            //$('#product-'+data.product_id).addClass('ItemAdded');
            setTimeout(function(){
              //$('#product-'+data.product_id).removeClass('ItemAdded');
              $('.grid-wrapper').find('.QuickshopTrigger').removeClass('Active')
            }, 3000);
          }
        },
        error: function(jqXHR, textStatus, errorThrown) {
          errorCallback 
            ? errorCallback(jqXHR.responseJSON.description)
            : alert(jqXHR.responseJSON.description);
        }
      });
    },

    updateCart: function(callback, openFlyout){
      
      $.getJSON('/cart.js', function(cart){
        Utilities.renderCartFlyout(cart, openFlyout);
        //callback && callback(cart);
      });
    },

    renderCartFlyout: function(cart, openFlyout){

      // FREE GIFT
      // Is the free gift in the cart?
      $.each(cart.items, function(i,el){
        if(el.id == liquidVars.giftProduct){
          Lemonade.cache.hasFreeGift = true;
          return false;
        }
      });

      // Update the free gift UI cart flyout and cart page
      if(Lemonade.cache.hasFreeGift){
        Lemonade.cache.$giftHeader.hide();
      } else if(cart.total_price > liquidVars.giftThreshold){
        Lemonade.cache.$addFreeGiftButton.removeClass('hide');
        Lemonade.cache.$giftMessage.hide();
      } else {
        const amountAway = parseInt(liquidVars.giftThreshold) - parseInt(cart.total_price);
        Lemonade.cache.$giftProgress.text(Shopify.formatMoneyCustom(amountAway));
      }

      if(cart.item_count === 0){
        Lemonade.cache.$cartFlyout.addClass('empty');
        Lemonade.cache.freeGiftAdded = false;
      } else {
        Lemonade.cache.$cartFlyout.removeClass('empty');
      }
      Lemonade.cache.$cartCount.text(cart.item_count > 0 ? '(' + cart.item_count + ')' : ''); 
      //Lemonade.cache.monogram_qty = 0;
  
      var source = $("#cart-template").html(),
          template = Handlebars.compile(source),
          items = [],
          mon_item = [],
          total = 0,
          total_qty = 0,
          total_monogram_qty = 0,
          monogrammed_class,
          img_small;
            
      $.each(cart.items, function(i,o){
        monogrammed_class = null;
        total_price = o.discounted_price * o.quantity;
        is_monogram = false;

        if (o.handle == 'monogram'){
          is_monogram = true;
        }
  
        if (o.properties){
          if (o.properties.Monogram != null){
            monogrammed_class = 'monogrammed';
            //Lemonade.cache.monogram_qty += o.quantity;
          } else {
            monogrammed_class = 'no-monogrammed';
          }
        }

        allowQty = true;

        if (o.product_title.includes('Test') || o.id == liquidVars.giftProduct){
          allowQty = false;
        }
                              
        // need to check country
        var single = convertNumber(o.discounted_price);
        var total = convertNumber(total_price);
              
        img_medium = o.image ? o.image.replace(/^(.+)(\..+)$/, '$1_medium$2') : '';
        items.push({
          id: o.id,
          vendor: o.vendor,
          title: o.product_title,
          url: o.url,
          qty: o.quantity,
          price: single,
          total: total,
          handle: o.handle,
          image: img_medium,
          variant_options: o.options_with_values,
          properties: o.properties,
          monogram: monogrammed_class,
          classes: (o.discounted_price) ? '' : 'free-item',
          shipNote: liquidVars.shipNote,
          isMonogram: is_monogram,
          allowQty: allowQty
        }); 
      });
      
      if (monogrammed_class != null && monogrammed_class != undefined){
        $('.shipping-msg').show();
      }
      
      //$('.cart-item.monogram input.quantity').val(Lemonade.cache.monogram_qty);
      // QuadPay Widgets
      if (cart.total_price < 3500) {
        $('#ProductQuadPayText-mini').html('on orders over ');
        $('#ProductQuadPayPrice-mini').html('$35');
      }else if (cart.total_price > 150000) {
        $('#ProductQuadPayText-mini').html('on orders up to ');
        $('#ProductQuadPayPrice-mini').html('$1500');
      }else {
        $('#ProductQuadPayText-mini').html('of');
        $('#ProductQuadPayPrice-mini').html( convertNumber(cart.total_price/4));
      }

      var sub_total = convertNumber(cart.total_price);
      $('#cart-flyout-subtotal-value').html(sub_total);
          
      $('#cart-flyout-products', Lemonade.cache.$cartFlyout).html( template({items:items}) );
      
      $('.cart-subtotal').find('.cart-price').html(sub_total);

      openFlyout && Utilities.openCartFlyout();

    },

    resizeCartFlyout: function(){
      var $products = $('#cart-flyout-products');
      $products.css('height', 'auto');
      var newHeight = 
        $(window).height() - 
        (
          $('#cart-flyout-summary').outerHeight() 
          + $('#cart-flyout-header').outerHeight() 
          + Lemonade.cache.$header.outerHeight()
        );
  
      if (newHeight > $products.outerHeight()) return;
      
      if (Lemonade.cache.$body.hasClass('loop-returns-activated')){
        newHeight = newHeight - 60
      }
      $products.css({
        height: newHeight
      });      
    }

  }

})();

(function($){


// Global selectors and values
Lemonade.cacheSelectors = function(){

	Lemonade.cache = {
		// general
		$win: $(window),
		$body: $('body, html'),
		$main: $('.main-content'),
		state: null,

		// header/nav
		$header: $('#site-header'),
    $headerWrap: $('.header-wrap'),
    $mobileMenu: $('#mobile-menu'),
    $screenCover: $('#screen-cover'),

		// collection
		$collection_slider: $('.collection-slider'),

    // blog/article
    $profile_bar: $('#profile-list-bar'),
    $profile_view: $('#profile-list-view'),

		// product
		is_monogram: false,
		monogram_id: 50141787846,
		monogram_price: 4000, // in cents
		monogram_cart_index: 0,
		monogram_qty: 0,

    $addToCartBtn: $('#AddToCartBtn'),
		$addToCartBtnText: $('#AddToCartText'),
		$addToCartBar: $('#AddToCartBar'),
		$addToCartBarText: $('#AddToCartBarText'),
		$addToCartForm: $('#AddToCartForm'),
    $productNote: $('#ProductNote'),
    $productPrice: $('#ProductPrice'),

		// cart page/flyout/ajax
    $cartFlyout: $('#cart-flyout'),
    $cartTrigger: $('.cart-trigger'),
    $cartClose: $('#cart-flyout-close'),
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',
    $cartCount: $('.cart-count'),
    
    lastCart: [],
    lastIter: 0,
    //MegaMenu
    old_trigger: false,
    freeGiftAdded: false,
    hasFreeGift: false,
    $giftHeader: $('.gift-header'),
    $addFreeGiftButton: $('.addFreeGift'),
    $giftMessage: $('.gift-msg'),
    $giftProgress: $('.gift-progress')
	};

};

// Kick off functions
Lemonade.init = function(){
  $.ajaxSetup({ cache: false });
	FastClick.attach(document.body);
  Lemonade.gdpr();
	Lemonade.cacheSelectors();
	Lemonade.mobileDetect();
	Lemonade.linksNewWindow();
	Lemonade.autoResponsiveElements();
	//Lemonade.cartPage();
	Lemonade.windowEvents();
  Lemonade.matchHeight();
  Lemonade.cache.$win.load(function(){
    Lemonade.fitVids();
  });
	Lemonade.accordion();
	Lemonade.buildSubMenus();
	Lemonade.accordions();
	Lemonade.megaMenu();
	Lemonade.search();
	Lemonade.openMobileMenu();
	Lemonade.closeMobileMenu();
	Lemonade.popup();
	$(document).ready(function(){
    Lemonade.Geofence();
    Lemonade.slick();	
    Lemonade.labandeSlider();
    Lemonade.featuredProducts();
		Lemonade.cache.$body.removeClass('hide');
    if ($('.iwishWrapper')) {
      Lemonade.wishlistPage();
    }
	});
	
	Lemonade.backToTop();
	Lemonade.newsletterForm();
	
	Lemonade.profileStick();
	Lemonade.profiles();
	Lemonade.videoPlayer();
	Lemonade.blogScroll();	  
  Lemonade.productHover();
  Lemonade.headerState();
  Lemonade.customSelects();
  Lemonade.mobileSubmenu();
  Lemonade.cartQty();

	Lemonade.cart = new Lemonade.initCartFlyout();
  Lemonade.cartPage = new Lemonade.initCartPage();

	// All product page logic
	if (Lemonade.cache.$body.hasClass('template-product')) {
		Lemonade.productPage();
	}

  if (Lemonade.cache.$body.hasClass('template-list-collections')) {
    if(Utilities.getQueryParam('year')){
      var $stories = $('.story-block');
      $stories.each(function(i,el){
        if(!$(el).hasClass(Utilities.getQueryParam('year'))){
          $(el).hide();
        }
      });
    }
    $('.template-list-collections .main-content').addClass('Show');
  }

	if (Lemonade.cache.$body.hasClass('template-collection') || Lemonade.cache.$body.hasClass('template-search')) {
    Lemonade.sampleSale();
    Lemonade.loadMoreProducts();
    Lemonade.collectionFilters();
	}  
  
  Lemonade.toggleCloverly('.country-select');
  Lemonade.animationFrame();
  Lemonade.relatedSoldOut();
  Lemonade.quickshop();

  $(".customWidth").stick_in_parent({
    offset_top: 80
  });

  if (Lemonade.cache.$body.hasClass('template-customers-login') || Lemonade.cache.$body.hasClass('template-customers-register')) {
    Lemonade.wishlistRedirect();
  }

  if ($('#page-anniversary').length != 0) {
    //Lemonade.loadMorePrdAnniversary();
  }
 
};

// Mobile detect
Lemonade.mobileDetect = function(){
	
	var isMobile = {
	  Android: function() {
	      return navigator.userAgent.match(/Android/i);
	  },
	  BlackBerry: function() {
	      return navigator.userAgent.match(/BlackBerry/i);
	  },
	  iOS: function() {
	      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	  },
	  Opera: function() {
	      return navigator.userAgent.match(/Opera Mini/i);
	  },
	  Windows: function() {
	      return navigator.userAgent.match(/IEMobile/i);
	  },
	  any: function() {
	      return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
	  }
	};
	
	if ( isMobile.any()){
		Lemonade.cache.$body.addClass('is-mobile');
	} else {
		Lemonade.cache.$body.addClass('not-mobile');
	}

};

// Open Footer Navigation links in new window if URL starts with http
Lemonade.linksNewWindow = function(){
  $('#site-footer').find('a[href^="http"]').not('a[href^=""]').attr('target', '_blank');
};

// Custom back button
Lemonade.backButton = function(){
  var referrerDomain = urlDomain(document.referrer);
  var shopDomain = urlDomain(document.url);

  if (shopDomain === referrerDomain) {
    history.back();
    return false;
  }

  function urlDomain(url) {
    var    a = document.createElement('a');
           a.href = url;
    return a.hostname;
  }
};

Lemonade.removeCartItem = function(el){
  var $item = $(el).closest('.cart-item'),
      variant_id = $item.data('variant');
  
  if (!variant_id) return false;

  Shopify.changeQueue = [];
  Shopify.changeQueue.push({
    lineId: $item.index()+1,
    quantity: 0
  });
  Shopify.changeAlong();
};

Lemonade.updateQuantity = function(el){
  var $button = $(el),
      $qty = $button.parent().find('.quantity'),
      lineId = $button.closest('.cart-item').index()+1,
      oldQty = newQty = $qty.val();

  if ($button.hasClass('up')) {
    newQty = parseFloat(oldQty) + 1;
  } else {
    if (oldQty > 0) {
      newQty = parseFloat(oldQty) - 1;
    } 
  }

  $qty.attr('value', newQty);

  Shopify.changeQueue = [];
  Shopify.changeQueue.push({
    lineId: lineId,
    quantity: newQty
  });

  // update cart items
  Shopify.changeAlong();	
}

// Cart page
Lemonade.initCartPage = function(){

  var $giftMessage = $('#gift-message'),
      $giftTextWrap = $('#GiftTextWrap'),
      $save = $('#SaveNote'),
      $delete = $('#DeleteNote'),
      $saved = $('.saved');

  function resetCartNote(){
    $.removeCookie('cart-note', { path: '/' });
    $giftMessage.val('');
    $save.show().addClass('disabled');
    $delete.hide();
    $saved.hide();
  }

  $('.cart-notes-toggle').on('click', function(e) {
    var $me = $(this);
    if ($me.hasClass('Active')){
      $me.removeClass('Active');
      $giftTextWrap.hide(); 
      resetCartNote();
    } else {
      $me.addClass('Active');
      $giftTextWrap.show(); 
    }
    
    Lemonade.cart.resizeCartFlyout();
  });

  $save.click(function(){
    var cartNote = $giftMessage.val();
    $.cookie('cart-note', cartNote, { path: '/' });
    $delete.show();
    $saved.show();
    $(this).hide();
    setTimeout(function(){
      $saved.hide();
    }, 3000);
  });

  $delete.click(function(){
    resetCartNote();
  });

  if (typeof $.cookie('cart-note') != 'undefined') {
    $giftMessage.val($.cookie('cart-note'));
    $delete.show();
    $save.hide();
    $('#gift-enable').click();
  }

  $giftMessage.keyup(function(event){
    event.preventDefault();
    if ($(this).val().length){
      $save.removeClass('disabled').show();
      $delete.hide();
    }

  });
  
  function renderCartPage(){
    $.getJSON('/cart.js', function(cart){

      if(cart.total_price > liquidVars.giftThreshold){
        Lemonade.cache.$addFreeGiftButton.removeClass('hide');
        Lemonade.cache.$giftMessage.hide();
      } else {
        const amountAway = parseInt(liquidVars.giftThreshold) - parseInt(cart.total_price);
        Lemonade.cache.$giftProgress.text(Shopify.formatMoneyCustom(amountAway));
      }      
      
      if(cart.item_count === 0){
        $('#cart-page-wrap').addClass('empty');
        Lemonade.cache.freeGiftAdded = false;
      } else {

        // FREE GIFT
        // Add the free gift from the cart page
        $('.cart-title').on('click', '.addFreeGift', function(){
          Lemonade.cache.freeGiftAdded = true;
          Utilities.addProductToCart({id: liquidVars.giftProduct, quantity: 1});
          $('.cart-title').find('.gift-header').hide();
        });

        $('#cart-page-wrap').removeClass('empty');
      }
      Lemonade.cache.$cartCount.text(cart.item_count > 0 ? '(' + cart.item_count + ')' : ''); 

      var source = $("#cart-page-template").html(),
          template = Handlebars.compile(source),
          items = [],
          total_monogram_qty = 0,
          monogrammed_class,
          hasMonograms = false;

      $.each(cart.items, function(i,o){
        if(o.title != 'Monogram'){
          if(o.properties && o.properties['Chunky Monogram'] || o.properties && o.properties['Monogram']){
            total_monogram_qty = total_monogram_qty + o.quantity;
            hasMonograms = true;
          }
        }
      });        

      $.each(cart.items, function(i,o){
        
        var total_price = o.discounted_price * o.quantity,
            is_monogram = false,
            isMonoArbon = false,
            isArbon = false,
            onSale = false,
            hasDiscounts = false;

        monogrammed_class = null;

        if(o.discounts.length > 0){
          hasDiscounts = true;
        }

        if (o.sku == 'MONOGRAM'){
          is_monogram = true;
          isMonoArbon = true;
        }

        if(o.title.includes('arbon')){
          isArbon = true;
          isMonoArbon = true;
        }

        if(o.original_price > o.price){
          onSale = true;
        }

        if (o.properties){
          if (o.properties.Monogram != null){
            monogrammed_class = 'monogrammed';
          } else {
            monogrammed_class = 'no-monogrammed';
          }
        }
                              
        // need to check country
        var single = convertNumber(o.discounted_price);
        var total = convertNumber(total_price);

        allowQty = true;

        if(o.product_title.includes('Test') || o.id == liquidVars.giftProduct){
          allowQty = false;
        } 
              
        img_medium = o.image ? o.image.replace(/^(.+)(\..+)$/, '$1_medium$2') : '';
        items.push({
          id: o.id,
          vendor: o.vendor,
          title: o.product_title,
          url: o.url,
          qty: o.quantity,
          price: single,
          total: total,
          sku: o.sku,
          handle: o.handle,
          image: img_medium,
          alt: o.product_title,
          variant_options: o.options_with_values,
          properties: o.properties,
          monogram: monogrammed_class,
          classes: (o.discounted_price) ? '' : 'free-item',
          shipNote: liquidVars.shipNote,
          isMonogram: is_monogram,
          isArbon: isArbon,
          isMonoArbon: isMonoArbon,
          total_monogram_qty: total_monogram_qty,
          hasMonograms: hasMonograms,
          shipNote: liquidVars.shipNote,
          onSale: onSale,
          hasDiscounts: hasDiscounts,
          discounts: o.discounts,
          allowQty: allowQty
        }); 
      });

      $('#cart-items-holder').html( template({items:items}) );
      
      $('.cart-subtotal').find('.cart-price').html(convertNumber(cart.total_price));

    });
  }

  $('#cart-items-holder').on('click', '.qty span', function() {
    Lemonade.updateQuantity(this);
  });

  $('#cart-items-holder').on('click', '.cart-item .remove', function() {
    Lemonade.removeCartItem(this);
  });

  renderCartPage();

  return {
    renderCartPage: renderCartPage
  }

};

// Wrap elements for responsive
Lemonade.autoResponsiveElements = function(){
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  //$('table').wrap('<div class="table-wrapper"></div>');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

// Return window width
Lemonade.windowWidth = function(){
  return Lemonade.cache.$win.width();
};

// Return window scrollTop
Lemonade.windowScrollTop = function(){
	return Lemonade.cache.$win.scrollTop();
};

// Return header height
Lemonade.headerHeight = function(){
	return Lemonade.cache.$header.height();
};

// Window events
Lemonade.windowEvents = function(){
	Lemonade.cache.$header.addClass('show');
	Lemonade.cache.$win.on({		
		load: function(){
			Lemonade.cache.$header.addClass('show');
			$('#load-screen').removeClass('show');
			setTimeout(function(){
				$('.product-details.standard, .product-details.accessories, .animate-text').addClass('show');
			}, 300);
		},
		resize: function(){
      Lemonade.windowWidth();
      Lemonade.profileStick();
		},
		scroll: function(){
			Lemonade.windowScrollTop();
			Lemonade.headerState();
		}
	});

};

// Faster animations
Lemonade.animationFrame = function(){

	(function loop(){
		requestAnimationFrame(loop);
		Lemonade.slickDots();
	})();

	//request animationframe polyfill
  (function() {
    var lastTime = 0;
    var vendors = ['', 'ms', 'moz', 'webkit', 'o'];

    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
			window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
			window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame) {
			window.requestAnimationFrame = function(callback, element) {
				var currTime = new Date().getTime();
				var timeToCall = Math.max(0, 16 - (currTime - lastTime));
				var id = window.setTimeout(function() { callback(currTime + timeToCall); },
					timeToCall);
				lastTime = currTime + timeToCall;
				return id;
			};
		}

    if (!window.cancelAnimationFrame) {
			window.cancelAnimationFrame = function(id) {
				clearTimeout(id);
			};
		}
  }());

};

// Body no scroll
Lemonade.noScroll = function(){
	Lemonade.cache.$body.addClass('no-scroll');
};

// Body yes scroll
Lemonade.yesScroll = function(){
	Lemonade.cache.$body.removeClass('no-scroll');
};

// PDP form position
Lemonade.formPos = function(){

	if (Lemonade.cache.$addToCartForm.length > 0){
		return Lemonade.cache.$addToCartForm.offset().top + Lemonade.cache.$addToCartForm.height();
	}

};

// Header State
Lemonade.headerState = function(){

	if (Lemonade.windowScrollTop() > 0){
		!Lemonade.cache.$header.hasClass('scrolled-past') && Lemonade.cache.$header.addClass('scrolled-past');
	} else {
		Lemonade.cache.$header.hasClass('scrolled-past') && Lemonade.cache.$header.removeClass('scrolled-past');
	}

};

// Match Height
Lemonade.matchHeight = function(){
	$('.mh').matchHeight();

	Lemonade.cache.$win.on({
		resize: function() {
			$('.mh').matchHeight();
		}
	});
};

// Fitvids
Lemonade.fitVids = function(){
  $('.video-wrapper').fitVids();
};

// Build mega menus out of standard sub menus
Lemonade.buildSubMenus = function(){
	$('.has-dropdown.large').each(function(i,el){
		$me = $(el);
		$me_sub = $me.find('.site-nav-dropdown');

    // if ($(this).parents('.secondary-menu').length) {
    //   $me_sub.css('top','115px');
    //   if($('body').hasClass('bar-active')){
    //     $me_sub.css('top','145px');
    //   }
    // }
		Lemonade.cache.$header.after($me_sub);
    $me_sub.find('.menu-wrapper').append(($me_sub).find('li.year'));
	});
 
 
};

// Accordions
Lemonade.accordions = function(){

  var $accTrigger = $('.acc-trigger'),
      $acc = $('.acc-content');
  
  // accordian content    
  $accTrigger.click(function(e){
	  e.preventDefault();
    var $me = $(this),
        $content = $me.next('.acc-content');
        
    $acc.slideUp();
    $(document.body).trigger("sticky_kit:recalc");
    if ($me.hasClass('open')){
      $me.removeClass('open');
			$content.removeClass('active')
      return false;
    }
    $accTrigger.removeClass('open');
    $me.addClass('open');
    $content.slideToggle().addClass('active');
    $(document.body).trigger("sticky_kit:recalc");
  });

};

// Mega Menus
Lemonade.megaMenu = function(){

	var $mega_trigger = $('.site-nav').find('.top-link'),
	    $mega_menu = $('.mega-menu'),
	    speed = 200,
 	    $me_panel = null,
	    openTimer,
	    closeTimer,
	    intentTimer;
	
	function closeShop($me){
		closeTimer = setTimeout(function(){
			$me.removeClass('activated');
			$('.mega-menu').removeClass('show');
			Lemonade.cache.$header.removeClass('menu-open');
		}, speed);
	}
	
	function openShop($me){
		if (!openTimer) {
	    openTimer = window.setTimeout(function() {
        timeoutId = null;
        trigger = $me.data('mega-trigger');
				$me_panel = $('#'+trigger);
				$me.stop().addClass('activated').siblings().removeClass('activated');
				clearTimeout(closeTimer);
				Lemonade.cache.$header.addClass('menu-open');
        console.log($me);
        if($me.hasClass('slim')){
          $me_panel.addClass('show').closest('.top-link').siblings('.top-link').find('.mega-menu').removeClass('show');
          $('.mega-menu.full').removeClass('show');
        } else {
          $me_panel.addClass('show').siblings('.mega-menu').removeClass('show');
        }
			}, speed);
 		}
	}

  function toggleShop(new_trigger, old_trigger){
    openShop(new_trigger);
    closeShop(old_trigger);
	}

	$('.site-nav-dropdown').on({
		mouseenter: function() {
			clearTimeout(closeTimer);
		}
	})

	$mega_trigger.on({
		mouseenter: function(){
			$me = $(this);
			var old_trigger = Lemonade.cache.old_trigger;
      var new_trigger = Lemonade.cache.old_trigger = $me;
      if (!new_trigger.hasClass('has-dropdown')) {
        window.clearTimeout(openTimer);
        openTimer = null;
        Lemonade.cache.old_trigger = false;
        closeShop($me);
      } else if (old_trigger == false) {
        openShop(new_trigger);
      } else if (new_trigger != old_trigger) {
        intentTimer = window.setTimeout(function(){
          window.clearTimeout(openTimer);
          openTimer = null;
          toggleShop(new_trigger, old_trigger);
        }, 500);
      }
		},
		mouseleave: function(){
		  window.clearTimeout(intentTimer);
		  intentTimer = null;
		}
	});

	$mega_menu.on({
		mouseenter: function(){
      window.clearTimeout(intentTimer);
      intentTimer = null;
		},
		mouseleave: function(){
		  window.clearTimeout(openTimer);
		  openTimer = null;
			closeShop($me);
			Lemonade.cache.old_trigger = false;
		}
	});
};

// Search Takeover
Lemonade.search = function(){

  var $globalSearch = $('#global-search'),
      $searchTrigger = $('.search-trigger'),
	    $searchInput = $globalSearch.find('.search-bar-inp'),
	    $closeSearch = $('#close-search');

  $searchTrigger.on('click', function(e){
    e.stopPropagation();
    e.preventDefault();
    Lemonade.cache.$screenCover.show();
    $(this).closest('li').addClass('active');
		Lemonade.cache.$header.addClass('search-open');
    $globalSearch.addClass('show');
    $searchInput.focus();
    setTimeout(function(){
      $closeSearch.addClass('show');
    }, 50);
	});

	$closeSearch.on('click', function(e){
		e.stopPropagation();
		closeSearch();
  });
  
  Lemonade.cache.$screenCover.on('click', closeSearch);

  function closeSearch() {
    if (!$globalSearch.hasClass('show')) return;
    
    $globalSearch.removeClass('show');
    $closeSearch.removeClass('show');
    $searchTrigger.closest('li').removeClass('active');
    $searchInput.val('').blur();
    Lemonade.cache.$header.removeClass('search-open');
    Lemonade.cache.$screenCover.hide();
  }

};

// Open the mobile menu
Lemonade.openMobileMenu = function(){
	$('#btn-mobile-menu').click(function(){
    Lemonade.cache.$mobileMenu.addClass('show-menu');
    Lemonade.cache.$screenCover.show();
    //Lemonade.noScroll();
	});
};

// Close the mobile menu
Lemonade.closeMobileMenu = function() {
	$('#close-mobile-menu').add(Lemonade.cache.$screenCover).click(function(e){
		e.stopPropagation();
    Lemonade.cache.$mobileMenu.removeClass('show-menu');
    Lemonade.cache.$screenCover.hide();
    Lemonade.yesScroll();
	});
};

// Mobile submenu switcher
Lemonade.mobileSubmenu = function() {
  var $mobileMenuPrimary = $('.mobile-menu-primary');
  var $mobileMenuSecondary = $('.mobile-menu-secondary');

  $('.mobile-submenu-trigger').on('click', function(e) {
    e.stopPropagation();
    e.preventDefault();
    var index = $(this).data('index');
    $mobileMenuPrimary.hide();
    $('.mobile-menu-secondary[data-index="' + index + '"]').show();
  });

  $(document).on('click', '.mobile-sub_submenu-trigger', function(e) {
    e.stopPropagation();
    e.preventDefault();
    $(this).closest('.mobile-submenu-link').toggleClass('is-show');
  });

  $('.mobile-menu-back').on('click', function(e) {
    e.stopPropagation();
    e.preventDefault();
    $mobileMenuSecondary.hide();
    $mobileMenuPrimary.show();
  });
}

// Popups
Lemonade.popup = function(){

	function sizeguidePopup(){
		$.fancybox.open([{
	    href: '#sizeguide-popup',
      autoSize: true,
      autoScale: true,
      fitToView: true,
	    maxWidth: 1560,
	    minHeight: 300
    }], {
	    padding: 4
    });
	}

  function votePopup(){
    $.fancybox.open([{
      href: '#vote-popup',
      autoSize: true,
      autoScale: true,
      fitToView: true,
      maxWidth: 900,
      minHeight: 388
    }], {
      padding: 15
    });
  }


  $('#newsletter-popup, #sizeguide-popup, #vote-popup').find('.close-x').click(function(){
	  $('.fancybox-close').click();
  });

  Lemonade.cache.$body.on('click', '.sizeguide-trigger', function(){
	  sizeguidePopup();
  });

  Lemonade.cache.$body.on('click', '.vote-popup-trigger', function() {
    votePopup();
  })

};

// Slick init
Lemonade.slick = function(){

	var $slick = $('.slick'),
	    $slick_arrows = $('.slide-arrow');

 function changeColor(the_slider) {
    
    var current_slick = the_slider.find('.slick-current'),
        slick_index = current_slick.attr('data-slick-index');

    the_slider.next('.custom-pag').find('li').eq(slick_index).addClass('slick-active').siblings('li').removeClass('slick-active');

    if (current_slick.hasClass('light')) {
      $slick_arrows.removeClass('dark').addClass('light');
    } else if (current_slick.hasClass('dark')) {
      $slick_arrows.removeClass('light').addClass('dark');
    }
  }

	if ($slick.length > 0){

		$slick.on('init', function() {
      changeColor($(this));
    });
    
		$slick.slick();
		
    $(window).on('keydown', function(e) {
      if (e.which == 37) {
        $slick.slick('slickPrev');
      }
      if (e.which == 39) {
        $slick.slick('slickNext');
      }
    });
		
		$slick.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			if (nextSlide != 0){
				$('#collection-slider').find('.billboard-text').removeClass('show');
			} else {
				$('#collection-slider').find('.billboard-text').addClass('show');
			}
		});
		
		$slick.on('afterChange', function(event, slick, currentSlide, nextSlide) {
      changeColor($(this));
      Lemonade.slickDots();
    });

		$('.pag-dot').click(function(){
			var me = $(this),
			    me_index = me.data('index'),
          me_slick = me.closest('.custom-pag').prev('.slick');

			if (!me.hasClass('slick-active')){
				me.addClass('slick-active').siblings().removeClass('slick-active');
				me_slick.slick('slickGoTo', me_index);
			}
		});

	}

};

// Slick custom dots
Lemonade.slickDots = function(){

	if (Lemonade.windowWidth() < 783){
		me_img_height = Lemonade.cache.$collection_slider.find('.slick-slider').find('.slick-current').find('img').height();
		Lemonade.cache.$collection_slider.find('.custom-pag').css({
			'bottom': 'inherit',
			'top': me_img_height - 30
		});
	} else {
		Lemonade.cache.$collection_slider.find('.custom-pag').css({
			'bottom': '10px',
			'top': 'inherit'
		});
	}

};

// Init LaBande section slider
Lemonade.labandeSlider = function(){

	var $slider = $('.labande-slider')

	if ($slider.length > 0){
		$slider.slick($slider.data('slick'));
	}

};

// Background videos
Lemonade.vide = function(){

	$('#hero-bg-vid').vide({
	  mp4: 'https://cdn.shopify.com/s/files/1/2233/8277/files/Maximum_Island_Final_loop_correct.mp4?58891',
	  webm: '',
	  ogv: '',
	  poster: ''
	});

};

// Back to top
Lemonade.backToTop = function(){
	$('.back-to-top').click(function(){
		$('html, body').animate({scrollTop:0},500);
	});
};

// Mailchimp Ajax newsletter form submit
Lemonade.newsletterForm = function(){

  var $form = $('.newsletter-form');

  $form.on('submit', function(e) {
    e.preventDefault();
    register($form);
  });

	function register($form) {
	  $.ajax({
	    type: $form.attr('method'),
	    url: $form.attr('action'),
	    data: $form.serialize(),
	    cache       : false,
	    dataType    : 'json',
	    contentType: "application/json; charset=utf-8",
      error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
      success     : function(data) {
        var msg = "Merci!";
        if (data.result != "success") {
          msg = "Sorry try again later.";
        }
        $form.find('.success').html(msg).fadeIn();
      }
	  });
	}

};

// Cart flyout
Lemonade.initCartFlyout = function(){
	function renderCartFlyout(show_flyout){
		$.getJSON('/cart.js', function(cart){

      $.each(cart.items, function(i,el){
        if(el.id == liquidVars.giftProduct){
          Lemonade.cache.hasFreeGift = true;
          return false;
        }
      });

      if(Lemonade.cache.hasFreeGift){
        Lemonade.cache.$giftHeader.hide();
      } else if(cart.total_price > liquidVars.giftThreshold){
        Lemonade.cache.$addFreeGiftButton.removeClass('hide');
        Lemonade.cache.$giftMessage.hide();
      } else {
        const amountAway = parseInt(liquidVars.giftThreshold) - parseInt(cart.total_price);
        Lemonade.cache.$giftProgress.text(Shopify.formatMoneyCustom(amountAway));
      }
      
			if(cart.item_count === 0){
        Lemonade.cache.$cartFlyout.addClass('empty');
        Lemonade.cache.freeGiftAdded = false;
      } else {
        Lemonade.cache.$cartFlyout.removeClass('empty');
      }
			Lemonade.cache.$cartCount.text(cart.item_count > 0 ? '(' + cart.item_count + ')' : ''); 
			//Lemonade.cache.monogram_qty = 0;
	
			var source = $("#cart-template").html(),
					template = Handlebars.compile(source),
					items = [],
					mon_item = [],
					total = 0,
					total_qty = 0,
					total_monogram_qty = 0,
					monogrammed_class,
					img_small;
          	
			$.each(cart.items, function(i,o){
				monogrammed_class = null;
				total_price = o.discounted_price * o.quantity;
        is_monogram = false;

        if (o.handle == 'monogram'){
          is_monogram = true;
        }
	
				if (o.properties){
					if (o.properties.Monogram != null){
						monogrammed_class = 'monogrammed';
						//Lemonade.cache.monogram_qty += o.quantity;
					} else {
						monogrammed_class = 'no-monogrammed';
					}
				}

        allowQty = true;

        if(o.product_title.includes('Test') || o.id == liquidVars.giftProduct){
          allowQty = false;
        }

        // need to check country
        var single = convertNumber(o.discounted_price);
        var total = convertNumber(total_price);
              
				img_medium = o.image ? o.image.replace(/^(.+)(\..+)$/, '$1_medium$2') : '';
				items.push({
					id: o.id,
					vendor: o.vendor,
					title: o.product_title,
					url: o.url,
					qty: o.quantity,
					price: single,
					total: total,
					handle: o.handle,
					image: img_medium,
					variant_options: o.options_with_values,
					properties: o.properties,
					monogram: monogrammed_class,
					classes: (o.discounted_price) ? '' : 'free-item',
          shipNote: liquidVars.shipNote,
          isMonogram: is_monogram,
          allowQty: allowQty
				}); 
			});

			if (monogrammed_class != null && monogrammed_class != undefined){
				$('.shipping-msg').show();
			}
			
			//$('.cart-item.monogram input.quantity').val(Lemonade.cache.monogram_qty);

      var sub_total = convertNumber(cart.total_price);
			$('#cart-flyout-subtotal-value').html(sub_total);
          
      $('#cart-flyout-products', Lemonade.cache.$cartFlyout).html( template({items:items}) );
      
      $('.cart-subtotal').find('.cart-price').html(sub_total);
      
	
			if (show_flyout) {
				resizeAndShowCartFlyout();
			}
		})

  }

  function addToCart(e){
    e.preventDefault();

    if (!Lemonade.cache.$addToCartForm.length) {
			return false;
		}

		Lemonade.cache.$addToCartBtn.attr('data-add-to-cart', Lemonade.cache.$addToCartBtnText.text()).prop('disabled', true).addClass('disabled btn--loading');
		$.ajax({
			url: '/cart/add.js',
			dataType: 'json',
			type: 'post',
			data: Lemonade.cache.$addToCartForm.serialize(),
			success: function(lineItem) {
        Lemonade.cache.$addToCartBtn.removeClass('btn--loading').prop('disabled', false).removeClass('disabled btn--loading');
				Lemonade.cache.lastIter = 0;
				Lemonade.cache.lastCart = [];

				Shopify.setMonograms();
        
        // add to cart event tracking
        Lemonade.addToCartEvent(lineItem);
			},
			error: function(XMLHttpRequest, textStatus) {
				var data = eval('(' + XMLHttpRequest.responseText + ')'),
						status = XMLHttpRequest.status;
				
				if (status === 422 && data.message == 'Cart Error') {
					Lemonade.cache.$productNote.text("Amount requested exceeds amount of available stock");
				} 
				else if (status === 422 && $('#productSelect option').length === 1) {
					Lemonade.cache.$addToCartBtnText.text("Sold Out");
				}
				else {
					Lemonade.cache.$addToCartBtnText.text(Lemonade.cache.$addToCartBtn.attr('data-add-to-cart'));
					Lemonade.cache.$addToCartBtn.prop('disabled', false).removeClass('disabled');
				}

				Lemonade.cache.$addToCartBtn.removeClass('btn--loading');
			}
		});
  };

  // function updateQuantity(el) {
	// 	var $button = $(el),
	// 			$qty = $button.parent().find('.quantity'),
	// 			lineId = $button.closest('.cart-item').index()+1,
  //       oldQty = newQty = $qty.val();
        
  //   if ($button.hasClass('up')) {
	// 		newQty = parseFloat(oldQty) + 1;
  //   } else {
  //     if (oldQty > 0) {
	// 			newQty = parseFloat(oldQty) - 1;
  //     } 
	// 	}

  //   $qty.attr('value', newQty);
		
	// 	Shopify.changeQueue = [];
	// 	Shopify.changeQueue.push({
	// 		lineId: lineId,
	// 		quantity: newQty
	// 	});

	// 	// update cart items
	// 	Shopify.changeAlong();		
	// }

	// function removeCartItem(el) {
	// 	var $item = $(el).closest('.cart-item'),
	// 			variant_id = $item.data('variant');

  //   console.log('hello');
		
	// 	if (!variant_id) return false;

	// 	Shopify.changeQueue = [];
	// 	Shopify.changeQueue.push({
	// 		lineId: $item.index()+1,
	// 		quantity: 0
	// 	});
	// 	Shopify.changeAlong();			
	// }
	
  function resizeCartFlyout() {
    var $products = $('#cart-flyout-products');
    $products.css('height', 'auto');
    var newHeight = 
      $(window).height() - 
      (
        $('#cart-flyout-summary').outerHeight() 
        + $('#cart-flyout-header').outerHeight() 
        + Lemonade.cache.$header.outerHeight()
      );

    if (newHeight > $products.outerHeight()) return;
    
    if (Lemonade.cache.$body.hasClass('loop-returns-activated')){
      newHeight = newHeight - 60
    }
    $products.css({
      height: newHeight
    });
  }

  function showCartFlyout() {
    Lemonade.cache.$cartFlyout.addClass('show');
    Lemonade.cache.$header.addClass('cart-open');
    Lemonade.cache.$screenCover.show();
    Lemonade.noScroll();
  }

  function resizeAndShowCartFlyout() {
    resizeCartFlyout();
    setTimeout(function(){
      showCartFlyout();
    }, 500);
  }

  function hideCartFlyout() {
    Lemonade.cache.$cartFlyout.removeClass('show');
    Lemonade.cache.$header.removeClass('cart-open');
    Lemonade.cache.$screenCover.hide();
    Lemonade.yesScroll();
	}
	
  renderCartFlyout(false);

	Lemonade.cache.$cartFlyout.on('click', '.qty span', function() {
    Lemonade.updateQuantity(this);
  });

	Lemonade.cache.$cartFlyout.on('click', '.remove', function() {
    Lemonade.removeCartItem(this);
  });

  Lemonade.cache.$addToCartBtn.on('click', addToCart);

	Lemonade.cache.$win.on('resize', resizeCartFlyout);
	
  // Lemonade.cache.$cartTrigger.on('click', function(e) {
  //   e.preventDefault();
  //   showCartFlyout();
  // });
  // Lemonade.cache.$screenCover.add(Lemonade.cache.$cartClose).on('click', hideCartFlyout)

	// product bar
  Lemonade.cache.$addToCartBar.click(function(){ 
		Lemonade.cache.$addToCartBtn.trigger('click'); 
  });
  
  $(window).load(function(){
    setTimeout(function(){
      resizeCartFlyout();
    }, 3500);
  });

  return {
    renderCartFlyout: renderCartFlyout,
    resizeCartFlyout: resizeCartFlyout,
    resizeAndShowCartFlyout: resizeAndShowCartFlyout,
    hideCartFlyout: hideCartFlyout,
    addToCart: addToCart
  }
};

// Profile bar stick
Lemonade.profileStick = function(){

  Lemonade.cache.$profile_bar.stick_in_parent({
    offset_top: Lemonade.cache.$headerWrap.height()
  }); 
  
};

Lemonade.cartQty = function() {
  var $qty = $('.cart .qty');
  var $up = $qty.find('.up');
  var $down = $qty.find('.down');

  $up.on('click', function() {
    var $inp = $(this).closest('.qty').find('.quantity');
    var oldQty = parseFloat($inp.val()) || 0;
    $inp.attr('value', oldQty + 1).val(oldQty + 1);
    $inp.trigger('input');
  });

  $down.on('click', function() {
    var $inp = $(this).closest('.qty').find('.quantity');
    var oldQty = parseFloat($inp.val()) || 0;
    if (oldQty > 0) {
      $inp.attr('value', oldQty - 1).val(oldQty - 1);
      $inp.trigger('input');
    }
  });

}


// GDPR Cookies 
Lemonade.gdpr = function(){
	var $gdpr = $('#Gdpr');

  if (typeof $.cookie('gdpr-modal') === 'undefined') {
		setTimeout(function(){
			$gdpr.addClass('show'); 
		}, 1500);

		$('#GdprAgree').click(function(){
			var $me = $(this);
			if ($me.is(':checked')){
				setTimeout(function(){
					$gdpr.removeClass('show');
				}, 400);
				$.cookie('gdpr-modal', '1', { expires: 90, path: '/' });
			}
		});

		$('#GdprDisagree').click(function(){
			var $me = $(this);
			if ($me.is(':checked')){
				setTimeout(function(){
					$gdpr.removeClass('show');
				}, 400);
				$.cookie('gdpr-modal', '0', { expires: 90, path: '/' });
			}
		});
	
  }
};


// Profile list
Lemonade.profiles = function(){
	function alphaList() {
		// Sort the recipe listings
		var mylist = $('#profile-menu');
		var listitems = mylist.children('a').get();
		listitems.sort(function(a, b) {
			var compA = $(a).text().toUpperCase();
			var compB = $(b).text().toUpperCase();
			return (compA < compB) ? -1 : (compA > compB) ? 1 : 0;
		});
		$(listitems).appendTo(mylist);
		setListColumns();
	}

	function setListColumns() {
	  var cols = ( $(window).width() < 768 ) ? 2 :  3,
		    links = $profile_menu.find('a'),
				len = links.length,
				split = Math.ceil(len / cols);

		for(var i = 0; i < len; i+=split) {
			links.slice(i, i+split).wrapAll("<div class='list-col'></div>");
		};	
	}


	var $profile_list = $('#profile-list'),
			$profile_menu = $('#profile-menu');
	
	alphaList();
  
  $('.profile-list-letters a').on('click', function(e) {
    e.preventDefault();
    var el = $(this).attr('href');
    var $el = $(el);

    if ($el.length === 0) return;

    var scrollTop = $el.offset().top - Lemonade.cache.$header.outerHeight() - Lemonade.cache.$profile_bar.outerHeight();
		Lemonade.cache.$body.animate({
      scrollTop: scrollTop
    });
  });

	Lemonade.cache.$profile_view.click(function(){
		$profile_list.fadeIn(function(){
			$profile_list.addClass('open');
			$profile_menu.addClass('show');
			Lemonade.noScroll();
		});
	});

	$('#close-list').click(function(){
		$profile_list.fadeOut(function(){
			$profile_list.removeClass('open');
			$profile_menu.removeClass('show');
			Lemonade.yesScroll();
		});
	});

};

// Video player
Lemonade.videoPlayer = function(){

	$('#about-video-wrap, img.hide-ph').click(function(){
		$('.hide-ph').css({'opacity': 0,'visibility': 'hidden'});
		$('#about-video-wrap').addClass('hide-me');
		document.getElementById("about-video").play();
	});

};

Lemonade.blogScroll = function(){ 
  
	$('.Lazy').Lazy({
		effect: 'fadeIn',
    visibilityOnly: true,
    threshold: 300,
		onError: function(element){
			// console.log('error loading ' + element.data('src'));
		}
	});  

};


Lemonade.customSelects = function(){
	var $selector_wrapper = $('.fake-select');
	
	$('.main-content').on('click', '.selector-wrapper .OptionSelect li:not(.sizeguide-trigger)', function(e){
		e.stopPropagation();
		var $me = $(this),
				me_val = $me.data('val'),
				me_text = $me.text(),
				$me_selector_wrapper = $me.closest('.selector-wrapper');

		if (!$me.hasClass('Active')){			
			$me
				.addClass('Active')
				.siblings('li')
				.removeClass('Active')
				.end()
				.closest('.selector-wrapper')
				.find('.single-option-selector')
				.val(me_val)
				.change();
		}
		
	});	

	$selector_wrapper.on('click keyup', '.OptionBox', function(e){
		e.stopPropagation();
		if (e.type == "click" || e.which == 13){
      var $me = $(this);
      if ($me.hasClass('Active')){
        $me
        .removeClass('Active')
        .next('.OptionSelect')
        .hide();          
      } else {
        $selector_wrapper.find('.OptionBox').removeClass('Active').next('.OptionSelect').hide();
        $me
        .addClass('Active')
        .next('.OptionSelect')
        .show();
        setTimeout(function(){
        $me.next('.OptionSelect').focus();
        }, 200);          
      }
		}
	});
};

Lemonade.productHover = function(){

  var $gridWrapper = $('.grid-wrapper');
	
	function hoverImg(el, state){
		var $me = el,
		    $me_img = $me.find('picture').not('.hover-img'),
		    $me_hover_img = $me.find('.hover-img');
		
		if ($me_hover_img.length > 0){
			if (state == 'enter'){
				$me_img.addClass('hide');
				$me_hover_img.removeClass('hide');
			} else {
				$me_img.removeClass('hide');
				$me_hover_img.addClass('hide');
			}
		}
	}

  $gridWrapper.on('mouseenter', '.grid-item-image', function(){
    var $me = $(this);
    hoverImg($me, 'enter');
  });

  $gridWrapper.on('mouseleave', '.grid-item-image', function(){
    var $me = $(this);
    hoverImg($me, 'leave');
  });  

};

Lemonade.variantChanger = function(options) {

  Lemonade.cacheSelectors();

  var moneyFormat = '',
			selector = options.selector,
      translations = options.translations,
			note = '',
      variant = options.variant,
      matching_var = null;

  $.each(options.all_options, function(i,el){
    if (variant && el.id == variant.id){
      matching_var = el.quantity;
      return false;
    }
  });

  //$("#preorder-waiver").prop('checked', false);

  function preorderCheck(){    
    if ($('#AddToCartBtn').hasClass('preorder')){
      $('#preorder-message').show();
      //$('#AddToCartBtn').addClass('disabled').prop('disabled', true);
    } else {
      $('#preorder-message').hide();
    }	
  }

  function setAddToCartState(quantity) {
    var $quantityElements = $('.quantity-selector, label + .js-qty'),
        state, 
        html,
        product_price;

    if (variant) {
      if (variant.available) {
        state = 'add_to_cart';
        if ($('#AddToCartBtn').hasClass('preorder')){
          state = 'preorder'
        }
      } else {
        state = 'sold_out';
      }
    } else {
      state = 'unavailable';
    }
    
    html = translations[state];
    productPriceHtml = '';

    if (variant) {
      if (variant.price < variant.compare_at_price) {
        product_price = Lemonade.cache.is_monogram ? (variant.price + Lemonade.cache.monogram_price) : variant.price;
        sale_price = Lemonade.cache.is_monogram ? (variant.compare_at_price + Lemonade.cache.monogram_price) : variant.compare_at_price;
        productPriceHtml += '<span>' + Shopify.formatMoneyCustom(product_price) + '</span><span class="price-sale">' + Shopify.formatMoneyCustom(sale_price) + '</span>';
      } else {
        product_price = Lemonade.cache.is_monogram ? (variant.price + Lemonade.cache.monogram_price) : variant.price;
        product_price = theme.Currency.formatMoney(product_price,theme.moneyFormat);
        productPriceHtml += ' <span>' + product_price + '</span>';
      }
    }

    //Lemonade.cache.$productPrice.html(productPriceHtml);

    if (state == 'sold_out' || state == 'unavailable') {
      $quantityElements.hide();
      $('.qp-container').hide();
      $('#preorder-message').hide();
          
      Lemonade.cache.$addToCartBtn.add(Lemonade.cache.$addToCartBar).addClass('disabled').prop('disabled', true).text(html);
      $('#back-in-stock').show();

    } else {
      $quantityElements.show();
      $('#back-in-stock').hide();
    
      if (state == 'preorder'){
        if ($("#preorder-waiver").is(':checked')){
          Lemonade.cache.$addToCartBtn.add(Lemonade.cache.$addToCartBar).html(html);
        } else {
          Lemonade.cache.$addToCartBtn.add(Lemonade.cache.$addToCartBar).addClass('disabled').prop('disabled', true).html(html);
        }
      } else {
        Lemonade.cache.$addToCartBtn.add(Lemonade.cache.$addToCartBar).removeClass('disabled').prop('disabled', false).html(html);
      }
    }
  }

  if (variant) {
    if (variant.available) {
      if (variant.inventory_management == 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity < 5) {
        note = 'Only ' + variant.inventory_quantity + ' left.';
      }
      Lemonade.cache.$productNote.text(note);
    } else {
      Lemonade.cache.$productNote.text('');
    }
  }

 $("#preorder-waiver").on('click', function(){
   var $me = $(this);
   if ($me.is(':checked')){
    $('#AddToCartBtn').removeClass('disabled').prop('disabled', false);
   } else {
    $('#AddToCartBtn').addClass('disabled').prop('disabled', true);
   }
 });
		
  preorderCheck();
	setAddToCartState(matching_var);
	

}

// All product page logic
Lemonade.productPage = function(){

	var $monogram_configurator = $('#monogram-configurator'),
      $monogram_overlay = $('#monogram-overlay'),
			$monogram_preview = $('#monogram-preview'),
      $current_monogram = $('#current-monogram'),
      $current_monogram_letters = $current_monogram.find('.current-monogram-letters'),
      $current_monogram_color = $current_monogram.find('.current-monogram-color'),
      $embroidery_swatches = $('#embroidery-swatches'),
      $embroidery_swatch = $embroidery_swatches.find('.swatch'),
      $add_monogram = $('#add-monogram'),
      $remove_monogram = $('#remove-monogram'),
      $preview_monogram = $('#preview-monogram'),
      first_product_image = null,
      first_height = null,
      requestId;

  // Product custom selects
  function customSelects(){

    var $selectWrap = $('.selector-wrapper');
        
    $selectWrap.each(function(i,el){
      var $me = $(el),
          $prod_variants = $me.find('.single-option-selector'),
          $label = $me.find('label'),
          label_handle = Shopify.handleize($label.text()),
          $options = $me.find('option'),
          $dummy = $('<ul class="dummy-select"></ul>'),
          $dummy_div = $('<div class="selector-wrapper"></div>');
          $dummy_bar = $('<ul class="dummy-select"></ul>'),
          $selection = $('<span class="header label">'+$label.text()+':</span>'),
          one_size = false;

      // build options in dummy select dropdown with data-attributes derived from real select
      $options.each(function(i, el){
        var $el = $(el),
            str = $el.val(),
            str = str.replace(/\s/g, "-");

        // active circle svg
        circle = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.77 22.08" data-radium="true" style="transition: opacity 0.5s cubic-bezier(0.694, 0.048, 0.335, 1);opacity: 0;position: absolute;left: 50%;top: 50%;width: 44px;transform: translate(-50%, -50%);"><path d="M4086.71,11173.34a13.77,13.77,0,0,0-1.6.33,11.84,11.84,0,0,0-1.46.46,12.11,12.11,0,0,0-1.45.71,17.61,17.61,0,0,0-1.5,1,4.12,4.12,0,0,0-.5.44c-0.1.1-.21,0.21-0.32,0.3a8.29,8.29,0,0,0-1.5,1.9,9.27,9.27,0,0,0-1,2.58,10.11,10.11,0,0,0-.25,1.76v0.13a13.32,13.32,0,0,0,0,1.49,8.79,8.79,0,0,0,.27,1.86l0.18,0.76,0.17,0.7c0,0.11.06,0.21,0.09,0.32l0,0.07c0,0.16.1,0.32,0.15,0.47s0.1,0.29.16,0.43,0.07,0.16.11,0.23l0,0.09a0.21,0.21,0,0,0,.15.11,0.19,0.19,0,0,0,.17-0.06l0.05-.05a0.24,0.24,0,0,0,0-.26l-0.06-.12a1.14,1.14,0,0,1-.09-0.21c0-.19-0.09-0.39-0.13-0.59s-0.11-.5-0.17-0.74l0-.13a11,11,0,0,1-.42-2.3v-0.14a17.58,17.58,0,0,1,0-2.16,8,8,0,0,1,.6-2.62,6.41,6.41,0,0,1,.43-0.86c0.3-.46.63-0.94,1-1.45a4.58,4.58,0,0,1,1.08-1l0.41-.29a13.92,13.92,0,0,1,1.19-.77c0.42-.23.86-0.42,1.29-0.61l0.54-.24,0.18-.06,0.35-.08,0.61-.14,0.29-.1a2.07,2.07,0,0,1,.33-0.1,2.85,2.85,0,0,1,.39,0l0.32,0,0.58-.08,0.61-.09a1,1,0,0,1,.22,0h0.53a5.93,5.93,0,0,1,.8,0,4.54,4.54,0,0,1,.56.13,3.77,3.77,0,0,0,.78.15,4,4,0,0,1,1.22.34l0.54,0.2a9.82,9.82,0,0,1,1.64.74,18,18,0,0,1,1.8,1.13c0.44,0.32.88,0.69,1.3,1.06l0.23,0.2c0.26,0.23.52,0.49,0.76,0.73s0.34,0.38.5,0.58l0.25,0.29c0.16,0.19.33,0.39,0.48,0.6a4.32,4.32,0,0,1,.31.56l0,0.08,0.15,0.28a3.49,3.49,0,0,1,.33.71l0.12,0.41a7.6,7.6,0,0,1,.34,1.44c0,0.14,0,.28.06,0.43a4.08,4.08,0,0,1,.07.64,14.21,14.21,0,0,1-.09,1.57,4.21,4.21,0,0,1-.23,1.11c-0.2.47-.45,0.92-0.68,1.36l-0.27.5a0.91,0.91,0,0,1-.13.21l-0.34.3a7.23,7.23,0,0,0-.57.54,4.8,4.8,0,0,1-1,.83c-0.11.07-.22,0.15-0.33,0.24a3.64,3.64,0,0,1-.32.22,3,3,0,0,1-.36.17l-0.26.12-0.21.12-0.22.13-0.47.19-0.44.18-0.23.12a1.41,1.41,0,0,1-.25.12,5.94,5.94,0,0,1-.58.15l-0.19,0a3.93,3.93,0,0,0-.51.17,2.81,2.81,0,0,1-.6.18l-0.46.09a2.78,2.78,0,0,1-.82.1,0.93,0.93,0,0,0-.43.1l-0.19.07-0.37.06-0.26,0-0.51.09c-0.33.06-.66,0.12-1,0.16a3.39,3.39,0,0,1-.56,0H4087l-0.64,0-0.19,0-0.32,0-0.39-.05-0.27-.07-0.32-.07-0.38-.05-0.41-.06-0.38-.1-0.24-.07-0.26-.06-0.41-.11-0.31-.13-0.28-.12-0.49-.18c-0.28-.1-0.56-0.2-0.83-0.32a8.4,8.4,0,0,1-1.21-.66c-0.29-.19-0.57-0.43-0.85-0.65l-0.36-.29a7.36,7.36,0,0,1-1.31-1.48,5.12,5.12,0,0,1-.47-0.84c-0.12-.25-0.22-0.54-0.31-0.81l-0.07-.2a7.25,7.25,0,0,1-.41-2.13,11,11,0,0,1,.23-2.34l0.07-.42a0.49,0.49,0,0,0-.25-0.6,0.29,0.29,0,0,0-.3,0,0.47,0.47,0,0,0-.19.37s0,0.08,0,.13a1.66,1.66,0,0,0,0,.19l0,0.22c0,0.35-.07.7-0.09,1v0.08c0,0.52-.06,1-0.06,1.58a4.73,4.73,0,0,0,.21,1.56c0.07,0.19.12,0.39,0.18,0.58a6.64,6.64,0,0,0,.27.82,9.65,9.65,0,0,0,1.22,2.08,7.27,7.27,0,0,0,1.57,1.49c0.3,0.22.6,0.4,0.94,0.6s0.77,0.46,1.15.65,0.62,0.29.92,0.42l0.24,0.1a5.76,5.76,0,0,0,.75.28c0.48,0.13,1,.25,1.66.39s1,0.2,1.52.27,0.73,0.08,1.09.1l0.22,0a6.82,6.82,0,0,0,.86,0c0.36,0,.72-0.06,1.08-0.1l0.72-.07c0.31,0,.63-0.06.95-0.11,0.64-.11,1.49-0.27,2.34-0.47a14,14,0,0,0,1.68-.51c0.6-.23,1.22-0.49,1.88-0.81a6.09,6.09,0,0,0,.62-0.36,6.14,6.14,0,0,1,.54-0.32,8.2,8.2,0,0,0,1.84-1.4,8,8,0,0,0,1.33-1.79,8.68,8.68,0,0,0,.65-1.57l0.08-.24a3.8,3.8,0,0,0,.15-0.9l0-.18c0-.13,0-0.25,0-0.38a7.4,7.4,0,0,0,.08-0.91c0-.1,0-0.2,0-0.3a17.54,17.54,0,0,0-.41-2.39,7.23,7.23,0,0,0-.58-1.62,8,8,0,0,0-1.3-2c-0.15-.15-0.28-0.32-0.42-0.48s-0.28-.34-0.43-0.5-0.55-.52-0.82-0.77l-0.22-.19-0.29-.24-0.19-.16-0.2-.17-0.23-.2-0.14-.1-0.08,0-0.07-.06a0.8,0.8,0,0,0-.17-0.13l-0.26-.15c-0.4-.23-0.81-0.46-1.22-0.67s-0.92-.46-1.38-0.67l-0.36-.17a3.2,3.2,0,0,0-.48-0.19l-0.54-.14-0.34-.09-0.39-.12a6.67,6.67,0,0,0-.84-0.22,12.59,12.59,0,0,0-1.9-.22,13.36,13.36,0,0,0-2,.15" transform="translate(-4075.18 -11173.19)" class="rmq-faf7cee0" data-radium="true"></path></svg>';
        custom_val = null;

        // size variants has specific svgs for the actual size label
        // build the custom selects in the form and the fixed bar
        custom_val = '<li class="'+str+' custom size" data-val="'+$el.val()+'">'+'<span>' + $el.text()+'</span>'+circle+'</li>';
        if (label_handle == 'color'){
          custom_val = '<li class="swatch '+str+'" data-val="'+$el.val()+'">'+$el.text()+'</li>';
        }

        $dummy.append(custom_val);
        $dummy_bar.append(custom_val);
      });
    
      // build each variant box in the bar
      bar_variant = $dummy_div.append('<span>'+$label.text()+':</span>').append($dummy_bar);

      // display the dummy selects in the form and bar
      $me.addClass(label_handle).prepend($dummy);
      $('.variant-bar').append(bar_variant);

      $me.prepend($selection);
      $label.add($prod_variants).hide();
  
			// place the size guide trigger inside the size variant container
			if (!one_size){
				if ($label.text() == 'Size' || $label.text() == 'SIZE' || $label.text() == 'size'){
					$me.append('<span class="sizeguide-trigger">Size Chart<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 115.186 2.548" data-radium="true"><path d="M115.057,0.61A1.8,1.8,0,0,0,114.4.39c-1.238-.069-2.477-0.116-3.715-0.163-0.354-.013-0.708,0-1.063,0V0.265c-1.181,0-2.362-.006-3.543,0a9.545,9.545,0,0,0-1.059.071c-1.406.167-2.807,0.367-4.215,0.512-1,.1-2,0.136-3,0.2-0.764.052-1.53,0.089-2.292,0.172q-1.848.2-3.69,0.454a19.952,19.952,0,0,1-3.178.113c-2.362-.049-4.721-0.159-7.082-0.222a10.854,10.854,0,0,1-2.109-.212A18.3,18.3,0,0,0,74.166.992c-1.3.089-2.59,0.188-3.886,0.272A4.471,4.471,0,0,1,69.4,1.252c-2.057-.27-4.126-0.211-6.191-0.283-1.3-.045-2.595-0.134-3.892-0.184C58.253,0.744,57.19.722,56.128,0.709a26.243,26.243,0,0,1-4.94-.321,14.418,14.418,0,0,0-3.356-.16c-0.767.026-1.535,0.021-2.3,0.024-2.361.013-4.722,0.034-7.084,0.027a18.044,18.044,0,0,1-2.47-.142A13.222,13.222,0,0,0,33.5.013c-0.531.024-1.063,0.043-1.594,0.027A8.713,8.713,0,0,0,30.157.2c-1.1.189-2.222,0.3-3.338,0.406C25,0.782,23.171.921,21.347,1.077c-0.353.03-.7,0.072-1.057,0.109a2.623,2.623,0,0,1-.7.064,22.252,22.252,0,0,0-3.89-.128c-2.539-.007-5.078.015-7.616,0.088-1.353.039-2.709,0.162-4.053,0.336A8.645,8.645,0,0,1,.868,1.469a1.641,1.641,0,0,0-.688.036A0.361,0.361,0,0,0,0,1.776a0.333,0.333,0,0,0,.122.282,3.4,3.4,0,0,0,.823.3,5.321,5.321,0,0,0,1.233.109A31.373,31.373,0,0,0,6.767,2.2a7.1,7.1,0,0,1,1.587-.111c1.89,0.046,3.777-.036,5.665-0.073,1.712-.034,3.423-0.028,5.135-0.04a21.116,21.116,0,0,0,3-.137,13.571,13.571,0,0,1,1.592-.075,14.145,14.145,0,0,0,3.168-.3A2.281,2.281,0,0,1,27.444,1.4C29.332,1.353,31.2,1.063,33.1,1.085c1.533,0.018,3.068-.038,4.6-0.032a18.169,18.169,0,0,1,2.47.162,9.675,9.675,0,0,0,2.292.015,12.764,12.764,0,0,1,2.824.016,5.224,5.224,0,0,0,1.585.008,14.4,14.4,0,0,1,4.238-.041c2.178,0.225,4.356.291,6.539,0.369,2.241,0.08,4.48.227,6.72,0.345,0.354,0.018.708,0.053,1.061,0.055,2.244,0.011,4.489.024,6.732,0.013,0.707,0,1.415-.061,2.12-0.117a13.454,13.454,0,0,1,4.229.145c0.515,0.122,1.053.151,1.573,0.259a6.024,6.024,0,0,0,1.762.1,36.685,36.685,0,0,1,6.017.106,25.25,25.25,0,0,0,4.947-.158c1.758-.21,3.52-0.341,5.288-0.453a19.988,19.988,0,0,0,3.868-.39,3.3,3.3,0,0,1,.7-0.094c2.359-.1,4.706-0.4,7.074-0.37,1.479,0.016,2.949.134,4.419,0.271a1.171,1.171,0,0,0,.854-0.115A0.441,0.441,0,0,0,115.185.9,0.356,0.356,0,0,0,115.057.61" data-radium="true"></path></svg></span>');
				}
			}

      if($('#AddToCartForm').hasClass('gift-card-form')){
        $('#AddToCartForm').find('.header.label').text('Amount:');
      }

    });

    // click evens on variant select
    $('body').on('click', '.dummy-select li', function(){
      var $me = $(this);
      
      if (!$me.hasClass('active')){
        var value = $me.data('val'),
            text = $me.text();

        $me.addClass('active').siblings('li').removeClass('active');

        $me
          .closest('.selector-wrapper')
          .find('.single-option-selector')
          .val(value)
          .trigger('change');
      }

    });
    
    $(window).load(function(){
      $('.selector-wrapper').each(function(){
        $(this).find('.dummy-select').find('li').first().click();
      });
    });
  };

	// Product Zoom
	function productZoom(){
		var $product_zoom = $('#product-zoom');

    function closeZoom(){
      $product_zoom.removeClass('show');
      setTimeout(function(){
        $product_zoom.find('div').removeClass('show-img');
        Lemonade.cache.$header.addClass('show');
        Lemonade.yesScroll();
      }, 500);
    }

		$('#product-image').find('img').click(function(){
      me_index = $(this).parent().index();
      if ($(this).parent().hasClass('slick-current')){
        me_index = $(this).parent().index() - 1;
      }

      Lemonade.cache.$header.removeClass('show');
      Lemonade.cache.$body.animate({scrollTop: 0}, function(){
        $product_zoom.addClass('show').find('div').eq(me_index).addClass('show-img');
        Lemonade.noScroll();
      });

      if ($(window).width() < 979){
        zoom({}, {scrollDisable: false});
      }

		});

    $product_zoom.click(function(e){
      var clicked_element = $(e.target);
      if ($(window).width() < 979) {
        if (clicked_element.hasClass('close-x-button')) {
          closeZoom();
        }
      }
      else {
        closeZoom();
      }
    });
	};
	
  function resetMiniPreview(){
    $current_monogram.hide().find('span').html('');
  }

	// Product toggle panels
	function monogramPanel(){

		var $monogram_info = $('#monogram-info'),
				$close_info = $('#close-monogram-info');

		$add_monogram.click(function(){
			$add_monogram.removeClass('Show');
			$monogram_configurator.show();
      $(document.body).trigger("sticky_kit:recalc");
      $remove_monogram.removeClass('Show');
      resetMiniPreview();
		});

		$('.monogram-info-trigger').click(function(){
			setTimeout(function(){
				$close_info.addClass('show');
			}, 50);
			$monogram_info.fadeIn(function(){
				Lemonade.noScroll();
			});
		});

		$("input#monogram-field").on('click keyup paste keypress blur keydown input', function(e) {
			var MonogramValue = $(this).val();
			$('#AddToCartForm').find($add_monogram).removeClass('Show');
			if ($(this).next('#monogram-field-submit').val() == ''){
				$add_monogram.html('Add Monogram');
			}else{
				$add_monogram.html('Edit Monogram');
				$('#monogram-field-submit').val(MonogramValue);
			}
		});

		$monogram_info.click(function(e){
			$monogram_info.fadeOut(function(){
				$close_info.removeClass('show');
				Lemonade.yesScroll();
			});
		});

		$monogram_configurator.find('.close-x').click(function(){
			$monogram_configurator.hide();
			$add_monogram.show();
      $(document.body).trigger("sticky_kit:recalc");
		});

		$monogram_preview.find('.close-x').click(function(){
			$monogram_preview.hide();
			$add_monogram.addClass('Show');
      $preview_monogram.removeClass('disabled');
		});

	};

	// Monogram Configurator
	function monogram(){

		var $monogram_field = $('#monogram-field'),
				$monogram_field_submit = $('#monogram-field-submit'),
				$monogram_font = $('#font-monogram'),
				$embroidery_color = $('#embroidery-color'),
        $purchase_monogram = $('#purchase-monogram'),
				$preview_btn = $('.preview'),
				has_letters = false,
				slash = '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 30.6 72.7" style="" xml:space="preserve"><path class="st0" d="M0,72.5c0.4-2.6,0.5-5.3,1.1-7.9c2.6-10.7,6.4-21.1,11-31.1c2.8-6,5.2-12.2,8-18.3c2.2-4.8,4.7-9.5,7.1-14.3c0.2-0.5,1-1.1,1.4-1c0.7,0.2,1.5,0.8,1.9,1.4c0.2,0.2-0.4,1.1-0.7,1.6c-1.9,3.3-3.8,6.5-5.6,9.8c-5.1,9-9.5,18.3-12.9,28.1c-2.3,6.5-4.6,13-6.8,19.5c-1.1,3.2-2,6.5-2.9,9.8C1.4,71,1,71.8,0.7,72.7C0.5,72.6,0.2,72.6,0,72.5z"/></svg>';

		$embroidery_swatch.click(function(){
			var me = $(this),
					me_color_name = me.data('color-name'),
					me_hex;

			if (!me.hasClass('active')){
				me.addClass('active').siblings().removeClass('active');
				me_hex = '#'+me.data('color');
				$('.color-name').text(me_color_name);
				$embroidery_color.val(me_color_name);
        $('.chunky-img.'+me_color_name).removeClass('Hide').siblings().addClass('Hide');
				$monogram_overlay
					.find('p')
					.css({'color': me_hex})
					.end()
					.find('svg')
					.css({'fill': me_hex});
			}
		});

		function cancelMonogram(){
			Lemonade.cache.is_monogram = false;
			//setAddToCartState();
			$monogram_preview.fadeOut(function(){
				$embroidery_swatch.first().click();
				$('#product-controller .controller-inner button').removeClass('active').eq(0).click();
			});
			$preview_btn.addClass('disabled').off('click');
			$purchase_monogram.addClass('disabled').find('span').html('Add Monogram');
			$monogram_field.blur();
			$monogram_field_submit.attr('disabled', true);
			$embroidery_color.attr('disabled', true);
			$monogram_font.attr('disabled', true);
			$monogram_field.val('');
      $remove_monogram.removeClass('Show');
      resetMiniPreview();
      $add_monogram.addClass('Show').html('Add Monogram');
			has_letters = false;
		}

		function monogramFont(){
			var $mF = $('#MonogramFont'),
			    $monogram_label = $('.MonogramLabel');

			$monogram_label.on('click', function(e){
				e.stopPropagation();
				var $me = $(this),
						me_list = $me.next('ul');

				if (!me_list.hasClass('show')){
					$me.addClass('active');
					me_list.addClass('show');
				} else {
					$me.removeClass('active');
					me_list.removeClass('show');
				}
			});

			$mF.find('li').click(function(){
				var $me = $(this),
						me_val = $me.attr('data-val'),
						me_text = $me.text();

				if (!$me.hasClass('current')){
					$me
						.addClass('current')
						.siblings('li')
						.removeClass('current')
						.closest('ul')
						.removeClass('show')
						.prev('.MonogramLabel')
						.removeClass('active')
						.addClass('selection-made');

					$monogram_label.text(me_text);
					$monogram_font.val(me_val);
					if (me_val == 'lowercase'){
						$monogram_label.addClass(me_val).removeClass('uppercase');
						word_val = $monogram_field_submit.val();
						word_val = word_val.toLowerCase();
						$monogram_field_submit.val(word_val);
            $current_monogram.addClass('lowercase').removeClass('uppercase');
					} else {
						$monogram_label.addClass(me_val).removeClass('lowercase');
						word_val = $monogram_field_submit.val();
						word_val = word_val.toUpperCase();
						$monogram_field_submit.val(word_val);
            $current_monogram.addClass('uppercase').removeClass('lowercase');
					}
					$monogram_overlay.find('p').removeAttr('class').addClass(me_val);
					$('#monogram-field').removeAttr('class').addClass(me_val);
				}

			});

		}

		$embroidery_swatch.first().click();

		// watch keyup event on monogram letter field
		$monogram_field.keyup(function(event){
			event.preventDefault();

			// Only allow Letters and Delete key else empty the field
			if ((event.which >= 65 && event.which <= 90) || event.which == 8){

				// get the values entered into the field on each keypress
				monogram_letter = $monogram_field.val();

				// get number of characters entered
				monogram_length = monogram_letter.length;

				// empty array for individual letters to get dumped into
				letters = [];

				// loop through the characters and wrap in spans. This is so the individual letters can be styled in CSS
				for(var i=0; i<monogram_length; i++) {
					// add slash svg to appropriate letter depending on how many monogram letters entered
					letter_with_slash = '<span class="letters-'+monogram_length+' '+monogram_letter.charAt(i)+'">'+monogram_letter.charAt(i)+slash+'</span>';
					letter_no_slash = '<span class="letters-'+monogram_length+'">'+monogram_letter.charAt(i)+'</span>';

					if (monogram_length == 1){
						if (i == 0){
							letters.push(letter_with_slash);
						}
					} else if (monogram_length == 2){
						if (i == 1){
							letters.push(letter_with_slash);
						} else {
							letters.push(letter_no_slash);
						}
					} else if (monogram_length == 3){
						if (i == 1){
							letters.push(letter_with_slash);
						} else {
							letters.push(letter_no_slash);
						}
					}
				}

				// enforce minimum of 1 letters
				if (monogram_length > 0){

					has_letters = true;

          $purchase_monogram.find('span').html('Save Monogram');

					// add monogram price one time only
					if (!Lemonade.cache.is_monogram && letters.length) {
						Lemonade.cache.is_monogram = true;
						//setAddToCartState();
					}
					// update the hidden text field with monogram letters. This is the field that gets submitted with the product
					$monogram_field_submit.attr('disabled', false).val(monogram_letter);

					// enable embroidery color field if letters entered
					$embroidery_color.attr('disabled', false);

					// enable the monogram font field if letters entered
					$monogram_font.attr('disabled', false);

					// update the overlay with the letters entered
					$monogram_overlay.find('p').html(letters);

					// make sure embroidery slash fill color is correct when viewing preview
					var embroidery_preview = $embroidery_swatches.find('.swatch.active').data('color');
          
					$monogram_overlay.find('svg').css({'fill': '#'+embroidery_preview});

					// if the overlay is not yet viewable
					if (!$monogram_preview.is(':visible')){ 
						// if viewer is not yet visible and values have been entered into the monogram text field
						// $('#purchase-monogram').removeClass('disabled').find('span').html('Monogram Added');
						$purchase_monogram.removeClass('disabled').addClass('active');
            var embroidery_color_name = $embroidery_swatches.find('.swatch.active').data('color-name');
            $current_monogram_letters.html($monogram_field.val());
            $current_monogram_color.html(embroidery_color_name);

						// activate the preview button
						$preview_btn.removeClass('disabled').on('click', function(e){
							e.preventDefault();
							// bring user to top of window (especially necessary on mobile)
							$('body, html').animate({scrollTop: 0}, function(){

								startAnimFrame();

                previewImageSize();

								// show the preview
								$monogram_preview.fadeIn();

								// disable the preview button if preview is active
								$preview_btn.addClass('disabled');

							});
						});
					}
				} else if ($monogram_field.val() === null || $monogram_field.val() === '') {
					has_letters = false;
					cancelMonogram();
          $add_monogram.removeClass('Show');
          $purchase_monogram.find('span').html('Add Monogram');
					stopAnimFrame();
				}

			} else {
				this.value = this.value.replace(/[^a-z]/gi,'');
			}
		});

		$(document).on('click','#purchase-monogram.active',function(e){
      var embroidery_color = $embroidery_swatches.find('.swatch.active').data('color');
      embroidery_color_name = $embroidery_swatches.find('.swatch.active').data('color-name');
			$monogram_configurator.hide();
      $add_monogram.html('Edit Monogram').addClass('Show').show()
      $remove_monogram.addClass('Show');
      $current_monogram_letters.html($monogram_field.val());
      $current_monogram_color.html(embroidery_color_name)
      $current_monogram.show();
      $monogram_preview.fadeOut();
      $preview_monogram.removeClass('disabled');
		});

		$(document).on('click','#monogram-configurator .close-x',function(){
			$add_monogram.addClass('Show');
		});

		// close monogram preview
    $monogram_configurator.on( 'click', '.close-x', cancelMonogram );

    $remove_monogram.on('click', function(){
      cancelMonogram();
    });
    
		monogramFont();
		
	};

	function swatchTitle(){

		var current_color = $('.color-swatches .swatch.active').attr('data-swatchtitle'),
		    timer; 

		if (current_color && current_color.includes('-')) {
			var split_color = current_color.replaceAll('-', ' ');
			$('.current-active-color').append(split_color);
		} else {
			$('.current-active-color').append(current_color);
		}

		$('.color-swatches .swatch').on({
			mouseenter: function(){
				var $me = $(this),
						me_color = $me.attr('data-swatchtitle');
				clearTimeout(timer);
				if (me_color.includes('-')) {
					var split_me_color = me_color.replaceAll('-', ' ');
					$('.color-swatches').find('.current-active-color').empty().append(split_me_color);
				}
				else {
					$('.color-swatches').find('.current-active-color').empty().append(me_color);
				}
			},
			mouseleave: function(){
				timer = setTimeout(function(){
					if (current_color && current_color.includes('-')) {
						var split_color = current_color.replaceAll('-', ' ');
						$('.current-active-color').empty().append(split_color);
					}
					else {
						$('.current-active-color').empty().append(current_color);
					}
				}, 300);
			}
		});

	}

	function productVideo(){

		var video = document.getElementById("video"),
				videoOverlay = document.getElementById("video-overlay"),
				videoPlaceholder = document.getElementById("video-placeholder"),
				playButton = document.getElementById("play-pause");
				
		if (video){
			videoPlaceholder.addEventListener("click", function(e) {
				e.stopPropagation();
				$(videoPlaceholder).addClass('started');
				$(videoOverlay).addClass('started');
				if (video.paused == true) {
					video.play();
					playButton.style.display = 'none';
					videoOverlay.style.display = 'none';
					videoPlaceholder.style.display = 'none';
				}
			});

			video.addEventListener("click", function(e) {
				e.stopPropagation();
				if (video.paused == false) {
					video.pause();
					playButton.style.display = 'block';
					videoOverlay.style.display = 'block';
					videoPlaceholder.style.display = 'block';
				}
			});
		}

	}

  // wide or narrow screen
  function windowState(){
    
    // init settings and selectors
    var $win = $(window),
				$body = $('body'),
				$product_slick = $body.find('.product-slick'),
        win_width,
        state,
        winState;
    
    // Check state of window width (wide vs narrow screen)
    var winState = function() {
      win_width = $win.width();
      if (win_width > 979){
        if (state != 'desktop') {
          state = 'desktop';
          changedstate(state);
          // console.log('desktop');
        };
      } else {
        if (state != 'mobile') {
          state = 'mobile';
          changedstate(state);
          // console.log('mobile');
        };
			}
			
    };
    
    function changedstate(mystate){
      if (mystate == 'desktop'){
				stickyKit();
      } else {
				detachStickyKit();
				if ($product_slick.hasClass('slick-initialized') == false){
					$product_slick.slick();
				}        
      }
    }
		  
    $win.on({
      resize: function(){
        winState();
			},
			load: function(){
				winState();
			}
    });
	}

	function detachStickyKit(){
		$(".recurate-false #product-details, .recurate-false #product-thumbs").trigger("sticky_kit:detach");
	}
	
	function stickyKit(){
		$(".recurate-false #product-details, .recurate-false #product-thumbs").stick_in_parent({
			offset_top: 100
		}); 
	}

	// Monogram previewer image resize
	var previewImageSize = function(){
    first_product_image = $('.product-slick').find('.product-media').first(),
    first_height = first_product_image.height() + 2;
    $monogram_preview.height(first_height);
	};  

	// Resize monogram letter size on window resize
	var monogramResize = function(){
		var monogram_width = $monogram_preview.width() * .0015;
		$monogram_overlay.css({
			'transform': 'scale('+monogram_width+')'
		});
	};

	function thumbScroll(){
		$('.thumb').click(function(e){
			var $me = $(this),
					me_image,
					scroll_to;

      if (!$me.hasClass('active')){
				$me.addClass('active').siblings('.thumb').removeClass('active');
				me_image = $me.attr('data-scroll-trigger');
				scroll_to = $('#'+me_image).offset().top;
				Lemonade.cache.$body.animate({scrollTop: scroll_to - 130});
			}

		});
	}
  
  function shuffleRelatedItems() {
    
    function getRandom(arr, n) {
      var result = new Array(n),
          len = arr.length,
          taken = new Array(len);
        
      if (n > len) throw new RangeError("getRandom: more elements taken than available");
      while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
      }
      return result;
    }    
    
    var shuffleItems = $('#related-wrap .shuffle');
    var items = $('#related-wrap .grid-item:not(.shuffle)');
    
    if(shuffleItems.length > 0) {  
      var randomItems = getRandom(shuffleItems, (4 - items.length));
      $(shuffleItems).not(randomItems).remove();
    }
  }

	(function($) {
		productZoom();
		monogramPanel();
		customSelects();
		monogram();
		swatchTitle();
		productVideo();
		windowState();
		shuffleRelatedItems();
		Lemonade.cache.$win.load(function(){
			//stickyKit();
		});
		thumbScroll();
	})(jQuery);


	function loopy(time) {
		requestId = undefined;
		monogramResize();
    previewImageSize();
		startAnimFrame();
	}

	function startAnimFrame() {
    if (!requestId) {
      requestId = window.requestAnimationFrame(loopy);
    }
	}	

	function stopAnimFrame() {
    if (requestId) {
      window.cancelAnimationFrame(requestId);
      requestId = undefined;
    }
	}	
	
}

Lemonade.sampleSale = function(){
  if (typeof $.cookie('sample-sale') != 'undefined') {
    $('#sample-form').remove();
    Lemonade.yesScroll();
  }
}

Lemonade.toggleCloverly = (el) => {
  
  const $this = $(el);
  const countryCode = $('option:selected', $this).attr('data-val');
  
  // only allow Cloverly to be added to US orders
  if (countryCode !== 'US') {
    // remove cloverly notes in cart
    Lemonade.cache.$cartFlyout
      .add('.cart')
      .addClass('international');
    
    // remove cloverly items from cart flyout
    $('.cart-item.carbon-offset-for-shipping').find('.remove').click();
    
    // remove items from cart page
    $('.cart-footer').addClass('international');
    
    $('[class*="CLOVERLY"] .cart-item-remove').length
      && $('[class*="CLOVERLY"] .cart-item-remove')[0].click();
    
  } else {
    Lemonade.cache.$cartFlyout
      .add('.cart')
      .removeClass('international');
  }    
}

Lemonade.relatedSoldOut = function(){
	if ($('#related-wrap .grid-item').hasClass('sold-out')) {
		$('#related-wrap').addClass('related-sold-out');
	}  
}

Lemonade.accordion = function(){
	
  var $accTrigger = $('.AccTrigger'),
      $acc = $('.AccContent');
  
  // accordian content    
  $accTrigger.click(function(e){
	  e.preventDefault();
    var $me = $(this),
        $content = $me.next('.AccContent');
        
    $acc.slideUp().removeClass('Show');
    if ($me.hasClass('Open')){
      $me.removeClass('Open');
      return false;
    }
    $accTrigger.removeClass('Open');
    $me.addClass('Open');
    $content.toggle().addClass('Show');
  });	
};

// Recurate: Set up Geofence so that users outside of the USA cannot use the platform;
Lemonade.Geofence = function() {
  geoip2.country(function(location) {
    let countryCode = location.country.iso_code;
    let currentLocation = window.location;

    if (countryCode != 'US' && countryCode != 'PH' ) {
      if ($('[href="/pages/pre-loved"]')) {
        $('[href="/pages/pre-loved"]').hide(); 
      }
      
      if ($('[href="/collections/re-ligne"]')) {
        $('[href="/collections/re-ligne"]').hide();
      }

      if (currentLocation.pathname.includes('/pages/pre-loved') || currentLocation.pathname.includes('/collections/re-ligne') || $("body").hasClass("productHideOutsideUS") == true) {
        currentLocation.href = currentLocation.origin + '/page/404';
      }
      
      if ($('.product-re-ligne')) {
        $('.product-re-ligne').hide();
      }
    }
  })
  
}

// Featured products section slider
Lemonade.featuredProducts = function(){
	let $sliderElm = $('.featured-products-slider');

	if ($sliderElm.length > 0){
		$sliderElm.slick($sliderElm.data('slick'));
	}
};


Lemonade.quickshop = function(){

  var currentSelection = null;

  // Quickshop: Size selection UX
  $('.grid-wrapper').add('.quickshop-products').on('click', '.QuickshopTrigger', function(){
    var $me = $(this);

    // Store the current selection variant ID
    currentSelection = $me.attr('data-variant-id');

    // Manage active state on option selections
    if(!$me.hasClass('Active')){
      $me.addClass('Active').siblings().removeClass('Active');
      Utilities.addProductToCart({id: currentSelection, quantity: 1});
    }

  });

  $('#cart-flyout').on('click', '.addFreeGift', function(){
    Utilities.addProductToCart({id: liquidVars.giftProduct, quantity: 1});
    $('#cart-flyout').find('.gift-header').hide();
  });

};

Lemonade.loadMoreProducts = function(){
  let $loadMore = $('#LoadMore');
  let pageNumber =  $loadMore.attr('data-current-page');

  function loadMore(button, pageNumber, path) {
    let wrap = button.closest('.btn-wrap').closest('.main-content').find('.AjaxPager'),
        maxpage = button.data('maxpage'),
        theQuery,
        url;
    
    if (!path) {
      path = location.pathname;
      theQuery = location.search;
    
      if (theQuery){
        url = path + theQuery + '&page=' + pageNumber;
      } else {
        url = path + '?page=' + pageNumber;
      }
    }
    
    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: url,
      data: theQuery,
      success: function(data) {
        let $data = $(data),
        $new_posts = $data.find(".AjaxPager").html();
        if ($data.length) {
          $(".AjaxPager").append($new_posts);

          dispatchEvent(new Event('load'));
          button.attr("disabled", false);
          if (maxpage === pageNumber) {
            button.hide();
            $('.LoadMoreWrapper').hide();
          } else {
            button.attr("disabled", false);
          }
        }
      },

      error: function(data) {
        return wrap.append('<div>Something Went Wrong</div>');
      }
    });
  }

  $loadMore.click(function(e) {
    pageNumber++;
    loadMore($(this), pageNumber);
  });
}

Lemonade.collectionFilters = function(){
  let toggleBtn = $('.collection-filtering .OptionTitle');
  let filterWrapper = $(".collection-filtering");

  toggleBtn.click(function() {
    filterWrapper.toggleClass('Active');
  })

  if (Lemonade.windowWidth() < 979){
    $('.facets__header').find('.close-x').click(function(){
      filterWrapper.removeClass('Active');
    });

    $('.filter-group').find('.filter__label').click(function(){
      $(this).toggleClass('Active');
      $(this).parent().find('.facets__list').slideToggle();
    });
  }

  let minSlider = $('.range-slider #min');
  let maxSlider = $('.range-slider #max');

  function renderPrices(fromValue, toValue) {
    $('.range-slider #from').html(`${fromValue}`);
    $('.range-slider #to').html(`${toValue}`);
  }

  maxSlider.on('input', () => {
    let minValue = parseInt(minSlider.val());
    let maxValue = parseInt(maxSlider.val());
    
    if (maxValue < minValue + 10) {
      minSlider.val(maxValue - 10);
      if (minValue === parseInt(minSlider.min)) {
        maxSlider.val(10);
      }
    }
  
    renderPrices(minValue, maxValue);
  })
  
  minSlider.on('input', () => {
    let minValue = parseInt(minSlider.val())
    let maxValue = parseInt(maxSlider.val())
   
    if (minValue > maxValue - 10) {
      maxSlider.val(minValue + 10);
      if (maxValue === parseInt(maxSlider.max)) {
        minSlider.val(parseInt(maxSlider.max) - 10);
      }
    }
  
    renderPrices(minValue, maxValue);
  })

}

// Wishlist: Add all prd to cart.
Lemonade.wishlistPage = function(){
  let btnATCAll = $('#cart-all');
  if (!btnATCAll) { return; }
  let products = $('.iwishItem');

  if (products.length == 0) {
    btnATCAll.hide();
  }
  
  // Update quantity.
  $('.iwishProducts .plus').on('click', function() {
    let quantity = parseInt($(this).parent().find('.in-num').val());
    $(this).parent().find('.in-num').val(quantity + 1);
    $(this).closest('form').find('[name="quantity"]').val($(this).parent().find('.in-num').val());
  })

  $('.iwishProducts .minus').on('click', function() {
    let quantity = parseInt($(this).parent().find('.in-num').val());
    if(quantity > 1) {
      $(this).parent().find('.in-num').val(quantity - 1);
      $(this).closest('form').find('[name="quantity"]').val($(this).parent().find('.in-num').val());
    }
    else {
      $(this).parent().find('.in-num').val(quantity);
      $(this).closest('form').find('[name="quantity"]').val($(this).parent().find('.in-num').val());
    }
  })
  
  // Hide Add all btn.
  $('.iwishRemoveBtn').on('click', function() {
    setTimeout(() => {
      if ($('.iwishItem').length == 0) {
        btnATCAll.hide();
      }
    }, 1000);
  })

  // Add all to cart.
  let formData = {
    'items': []
  }
  products.each(function(){
    let quantity = parseInt($(this).find('[name="quantity"]').val());
    let prdID = parseInt($(this).find('[name="id"]').val());
    formData.items.push({
      quantity: quantity,
      id: prdID
    });
  })

  btnATCAll.on('click', function() {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      success: function (cart) {
        window.location.href = window.location.origin + '/cart';
      }
    });
  })
}

Lemonade.wishlistRedirect = function(){
  var pdp_url = false;
  
  if(Shopify.queryParams('wishlist_redirect')){
    pdp_url = decodeURIComponent(Shopify.queryParams('wishlist_redirect'));
  }
  
  $(window).load(function(){
    if(pdp_url){
      $('.wishlist_product_redirect').val(pdp_url);
    } else {
      $('.wishlist_product_redirect').remove();
    }
  });
}

// add to cart event tracking
Lemonade.addToCartEvent = (data) => {
  
  // Google Floodlight Event
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'addToCart',
    productId: data.itemID,
  });
  
  // Klaviyo Event
  var cart = {
    product_id: data.product_id,
    product_title: data.product_title,
    variant_title: data.variant_title,
    quantity: data.quantity,
    $value: (data.price * data.quantity)/100,
  }
  _learnq.push(['track', 'Added to Cart', cart])
}

// Load more product anniversary
Lemonade.loadMorePrdAnniversary = () => {
  let x, size_li;
  function changeLoadCount(media) {
    x = ( $(window).width() < 768 ) ? 8 : 9;
    $(".products-anniversary .grid-item").hide();
    $(".products-anniversary .grid-item:lt(" + x + ")").show();
    size_li = $(".products-anniversary .grid-item").size();
    if (x == size_li) {
      $("#loadMore").hide();
    } else {
      $("loadMore").show();
    }
  }

  var media = window.matchMedia("(max-width: 768px)");
  changeLoadCount(media);
  media.addListener(changeLoadCount);
  window.addEventListener("load resize", function () {
    changeLoadCount(media);
    media.addListener(changeLoadCount);
  });

  function loadMore() {
    $(".products-anniversary .grid-item").hide();
    size_li = $(".products-anniversary .grid-item").size();
    $(".products-anniversary .grid-item:lt(" + x + ")").show();

    $("#loadMore").click(function () {
      x = x + x <= size_li ? x + x : size_li;
      
      console.log(x);
      $(".products-anniversary .grid-item:lt(" + x + ")").show();
      if (x == size_li) {
        $("#loadMore").hide();
      } else {
        $("#loadMore").show();
      }
    
    });
  }
  loadMore();
}

// Initialize Lemonade JS on docready
$(Lemonade.init);
})(jQuery);